import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromoEmployment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 7,
			r: 3,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 8,
			r: 2.5,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 19c0-3.314 3.134-6 7-6s7 2.686 7 6",
			stroke: "#2917D6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 13c2.21 0 4 1.567 4 3.5",
			stroke: "#2917D6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			fill: "none"
		})
	]
});
export default SvgPromoEmployment;
